import { render } from "./QuotaBalance.vue?vue&type=template&id=c7b37e28"
import script from "./QuotaBalance.vue?vue&type=script&lang=js"
export * from "./QuotaBalance.vue?vue&type=script&lang=js"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__